'use client';

import { datadogRum } from '@datadog/browser-rum';
import { usePathname } from 'next/navigation';
import { useEffect, type PropsWithChildren } from 'react';

import { STATIC_EXPERIMENT_CONFIG } from '../experiments';

type Props = PropsWithChildren<{
  serverSideExperimentDecision: string;
}>;

export function LogStaticExperiments({ children, serverSideExperimentDecision }: Props) {
  const pathname = usePathname();

  const staticExperimentName = STATIC_EXPERIMENT_CONFIG[pathname];

  useEffect(() => {
    if (staticExperimentName) {
      datadogRum.addFeatureFlagEvaluation(
        // The hyphen is not allowed according to DD documentation
        //  https://docs.datadoghq.com/real_user_monitoring/guide/setup-feature-flag-data-collection/?tab=browser#feature-flag-naming
        staticExperimentName?.replace('-', '_'),
        serverSideExperimentDecision,
      );
      datadogRum.addAction('Static ABSmartly Bucketing', {
        staticExperimentName,
      });
    }
  }, [staticExperimentName]);

  return <>{children}</>;
}
